/**************************************************************************************************************************************************
*   MODULE NAME     :  MetricResults
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  14-04-2021
*   DESCRIPTION     :  Component to load Show All Metrics page
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/
import React from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Tooltip,
  OverlayTrigger,
  Button,
  Tabs,
  Tab,
  ListGroup,
} from "react-bootstrap";
import {
  FaSpinner,
  FaEye,
  FaSearch,
  FaTrashAlt,
  FaFilter,
  FaPlusSquare,
} from "react-icons/fa";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { FromToDatePicker } from "../common/datePicker/MyDatePicker";
import DataTable from "../common/dataTable/DataTable";
import { loadAbstractsData } from "../../actions/homeActions";
import * as Helper from "../abstracts/Common/abstractHelper";
import { ddmmmyyyyFormat } from "../common/DateFormat";
import { exportPDF } from "../common/ExportToPDF";
import { } from "../common/MessagesPool";
import queryString from "query-string";
import {
  loadAllProduct,
  loadAllCountry,
  loadAllExplanation,
  loadAllStatus,
} from "../../actions/abstractActions";
import { loadOtherMetrics } from "../../actions/metricActions";
import { loadUsersData } from "../../actions/userActions";


class MetricResults extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      otherMetrics: [],
      searchCriteriaObject: {},
      masterData: {
        productList: this.props.productData,
        statusList: this.props.statusData,
        explanationList: this.props.explanationData,
        countryList: this.props.countryData,
        userList: this.props.usersData,
      },
      selectedCols: [],
    };
  }

  async componentDidMount() {
    this.setLoader(true);
    try {
    await Promise.all([this.getAllUsers(), this.loadAllProduct(), this.loadAllCountry(), this.loadAllStatus(), this.loadAllExplanation()]);
    let obj = queryString.parse(this.props.location.search);
    Object.keys(obj).forEach((key) => {
      if (key.toLowerCase().includes("date")) {
        obj[key] = JSON.parse(obj[key]);
      } else if (key === "statusId" || key === "selectedMetrics") {
        if (!Array.isArray(obj[key])) obj[key] = [obj[key]];
        obj[key] = obj[key].map(id => +id);
      } else if (key.toLowerCase().includes("id") && !key.includes("case") && key != "caseIds") {
        obj[key] = +obj[key];
      } else if (key.includes("include")) {
        obj[key] = +obj[key];
      }
    });
    this.setState({
      searchCriteriaObject: obj,
    });
      let res = await this.props.loadOtherMetrics(obj);
      if (res && res.data && res.data.result) {
        let data = res.data.result;
        this.setState({
          otherMetrics: data,
        });
      }
    } catch (e) {
      this.setLoader(false);
    }
    this.setLoader(false);
  }

    getAllUsers = async () => {
      let arr = this.state.masterData.userList;
      if (!(this.state.masterData.userList && this.state.masterData.userList.length > 0)) {
          let response = await this.props.loadUsersData();
          arr = response.data.result
      }
      let resultData = this.formatUserList(arr);
      this.setState(prevState => ({
          masterData: {
              ...this.state.masterData,
              userList: resultData
          }
      })
      );

  }
  loadAllProduct = async () => {
      let arr = this.state.masterData.productList;
      if (!(this.state.masterData.productList && this.state.masterData.productList.length > 0)) {
          let response = await this.props.loadAllProduct();
          arr = response.data.result
      }
      let resultData = this.formatMasterDataList(arr);
      this.setState(prevState => ({
          masterData: {
              ...this.state.masterData,
              productList: resultData
          }
      })
      );

  }

  loadAllCountry = async () => {
      let arr = this.state.masterData.countryList;
      if (!(this.state.masterData.countryList && this.state.masterData.countryList.length > 0)) {
          let response = await this.props.loadAllCountry();
          arr = response.data.result
      }
      let resultData = this.formatMasterDataList(arr);
      this.setState(prevState => ({
          masterData: {
              ...this.state.masterData,
              countryList: resultData
          }
      })
      );

  }

  loadAllExplanation = async () => {
      let arr = this.state.masterData.explanationList;
      if (!(this.state.masterData.explanationList && this.state.masterData.explanationList.length > 0)) {
          let response = await this.props.loadAllExplanation();
          arr = response.data.result
      }
      let resultData = this.formatMasterDataList(arr);
      this.setState(prevState => ({
          masterData: {
              ...this.state.masterData,
              explanationList: resultData
          }
      })
      );
  }

  loadAllStatus = async () => {
      let arr = this.state.masterData.statusList;
      if (!(this.state.masterData.statusList && this.state.masterData.statusList.length > 0)) {
          let response = await this.props.loadAllStatus();
          arr = response.data.result
      }
      let resultData = this.formatMasterDataList(arr);
      this.setState(prevState => ({
          masterData: {
              ...this.state.masterData,
              statusList: resultData
          }
      })
      );
  }
  formatMasterDataList = (dataArr = []) => {
    let result = dataArr.map((obj) => {
      return {
        label: obj.masterDataValue,
        value: obj.masterDataId,
      };
    });
    return result;
  };
  formatUserList = (dataArr = []) => {
    let result = dataArr.map((obj) => {
      return {
        label: obj.firstName + " " + obj.lastName,
        value: obj.systemId,
      };
    });
    return result;
  };

  setLoader = (isLoading) => this.setState({ isLoading });

  handleBackFunction = () => {
    window.close();
  };
  exportFile() {

    const { otherMetrics,searchCriteriaObject } = this.state;
    var widths = [300, 195]
    let criteriaStrPdf = this.generateCriteriaStr()
    let colSelected = ["title", "source"];
    var headers = [["Title", "Source"]];
    if (searchCriteriaObject && searchCriteriaObject.selectedMetrics) {
      if (searchCriteriaObject.selectedMetrics.includes(1)) {
        headers[0].push("Calendar days from initial abstract receipt date to completion of Abstract review ");
        widths.push(72);
        colSelected.push("case1");
      }
      if (searchCriteriaObject.selectedMetrics.includes(2)) {
        headers[0].push("Calendar days from initial abstract receipt to Non-valid article closeout");
        widths.push(72);
        colSelected.push("case2");
      }
      if (searchCriteriaObject.selectedMetrics.includes(3)) {
        headers[0].push("Calendar days from article ordered to receipt of article")
        widths.push(72);
        colSelected.push("case3");
      }
    } else {

    }
    otherMetrics.sort((a, b) => (a.title > b.title) ? 1 : -1)
    const dataDashboard = otherMetrics.map(elt => {
      let element = [];
      colSelected.forEach(ele => {
        let dt = ele.includes("date") && elt[ele] ? ddmmmyyyyFormat(elt[ele]) : (elt[ele] ? elt[ele] : "");

        element.push(dt)
      })
      return element;
    }
    )
    exportPDF("Metrics Results", "", headers, dataDashboard, widths, "Criteria - " + criteriaStrPdf)
  }
  generateCriteriaStr() {
    let { searchCriteriaObject, masterData } = this.state;
    let criteriaStr = ""
    if (!searchCriteriaObject) return ""
    Object.keys(searchCriteriaObject)
      .filter((key) => ((searchCriteriaObject[key] || key.includes("include")) && key !== "selectedMetrics"))
      .map(function (key) {
        let val = searchCriteriaObject[key];
        let _key = key;
        try {
          _key = _key.replace(/([-_][a-z])/gi, ($1) => {
            return $1.toUpperCase().replace("-", "").replace("_", "");
          });
          _key = _key.replace(/([A-Z])/g, " $1");
          _key = _key.charAt(0).toUpperCase() + _key.slice(1);

          if (key.includes("include")) {
            val = val === 0 ? "False" : "True";
          } else if (key.toLowerCase().includes("date")) {
            let fromTo = val;
            let val1 = fromTo["from"]
              ? ` From ( ${ddmmmyyyyFormat(fromTo["from"])} )`
              : "";
            let val2 = fromTo["to"]
              ? ` To ( ${ddmmmyyyyFormat(fromTo["to"]
              )} )`
              : "";
            val = val1 + val2;
          } else if (
            ["status", "explanation", "product", "country"].some((el) =>
              key.includes(el)
            )
          ) {
            val = masterData[
              key.substr(0, key.length - 2) + "List"
            ].filter((e) => val.toString().includes(e.value));
            _key = _key.substr(0, _key.length - 3);
            let str = "";
            val.map((e) => {
              str = str + e.label + ", ";
            });
            val = str.slice(0, -2);
          } else if (key.includes("caseManager")) {
            switch (key) {
              case "caseManagerId1":
                _key = "Abstract Record Screener";
                break;
              case "caseManagerId2":
                _key = "Full Text Screener";
                break;
              case "caseManagerId3":
                _key = "Record Closer";
                break;
              default:
                _key = "Case Manager";
                break;
            }
            val = masterData["userList"].filter((e) =>
              e.value.includes(val)
            );
            val = val[0].label;
          }
        } catch (e) {
          _key = "";
          val = "";
        }
        criteriaStr = criteriaStr + `${_key}  :  ${val}` + " ; ";

      });
    return criteriaStr;
  }
  fromCriteria = () => {
    let { searchCriteriaObject, masterData } = this.state;
    if (!searchCriteriaObject) return ""
    return (
      <ListGroup className="criteriacss" horizontal>
        {Object.keys(searchCriteriaObject)
          .filter((key) => ((searchCriteriaObject[key] || key.includes("include")) && key !== "selectedMetrics"))
          .map(function (key) {
            let val = searchCriteriaObject[key];
            let _key = key;
            try {
              _key = _key.replace(/([-_][a-z])/gi, ($1) => {
                return $1.toUpperCase().replace("-", "").replace("_", "");
              });
              _key = _key.replace(/([A-Z])/g, " $1");
              _key = _key.charAt(0).toUpperCase() + _key.slice(1);

              if (key.includes("include")) {
                val = val === 0 ? "False" : "True";
              } else if (key.toLowerCase().includes("date")) {
                let fromTo = val;
                let val1 = fromTo["from"]
                  ? ` From ( ${ddmmmyyyyFormat(fromTo["from"])} )`
                  : "";
                let val2 = fromTo["to"]
                  ? ` To ( ${ddmmmyyyyFormat(fromTo["to"]
                  )} )`
                  : "";
                val = val1 + val2;
              } else if (
                ["status", "explanation", "product", "country"].some((el) =>
                  key.includes(el)
                )
              ) {
                val = masterData[
                  key.substr(0, key.length - 2) + "List"
                ].filter((e) => val.toString().includes(e.value));
                _key = _key.substr(0, _key.length - 3);
                let str = "";
                val.map((e) => {
                  str = str + e.label + ", ";
                });
                val = str.slice(0, -2);
              } else if (key.includes("caseManager")) {
                switch (key) {
                  case "caseManagerId1":
                    _key = "Abstract Record Screener";
                    break;
                  case "caseManagerId2":
                    _key = "Full Text Screener";
                    break;
                  case "caseManagerId3":
                    _key = "Record Closer";
                    break;
                  default:
                    _key = "Case Manager";
                    break;
                }
                val = masterData["userList"].filter((e) =>
                  e.value.includes(val)
                );
                val = val[0].label;
              }
            } catch (e) {
              _key = "";
              val = "";
            }
            return (
              <ListGroup.Item key={key} className="py-1 px-1">{`${_key}  :  ${val}`}</ListGroup.Item>
            );
          })}
      </ListGroup>
    );
  };

  render() {
    const { isLoading, otherMetrics, searchCriteriaObject } = this.state;

    let columns = [
      {
        dataField: "abstractId",
        text: "",
        hidden: true,
      },
      {
        dataField: "title",
        text: "Title",
        sort: true,
      },
      {
        dataField: "source",
        text: "Source",
        sort: true,
      },
      {
        dataField: "case1",
        text: "Calendar days from initial abstract receipt date to completion of Abstract review ",
        hidden: !searchCriteriaObject || !searchCriteriaObject.selectedMetrics || !searchCriteriaObject.selectedMetrics.includes(1),
        headerClasses: "width-150",
        sort: true
      },
      {
        dataField: "case2",
        text: "Calendar days from initial abstract receipt to Non-valid article closeout",
        hidden: !searchCriteriaObject || !searchCriteriaObject.selectedMetrics || !searchCriteriaObject.selectedMetrics.includes(2),
        headerClasses: "width-150",
        sort: true
      },
      {
        dataField: "case3",
        text: "Calendar days from article ordered to receipt of article",
        hidden: !searchCriteriaObject || !searchCriteriaObject.selectedMetrics || !searchCriteriaObject.selectedMetrics.includes(3),
        headerClasses: "width-150",
        sort: true
      },
    ];

    return (
      <>
        <table className="print-table">
          <thead>
            <tr>
              <td>
                <div className="page-header-space"></div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="CommonWrap">
                  <Container fluid>
                    <div className="headerpart headerpartCustom">
                      <Row>
                        <Col sm={9}>
                          {" "}
                          <h1>Metrics Results</h1>
                        </Col>
                        <Col className="text-right mt-3 col">
                          <Button
                            variant="primary"
                            type="submit"
                            className="mr-2 btn btn-primary"
                            onClick={this.handleBackFunction}
                          >
                            Close
                  </Button>
                          <Button
                            variant="primary"
                            type="submit"
                            className="mr-2 btn btn-primary"
                            onClick={() => { this.exportFile() }}
                          >
                            Print All
                        </Button>
                        </Col>
                      </Row>
                    </div>
                    <Row className="mb-3 ml-2 mr-2">
                      <div className="mb-0 saveTitlecss mt-0">
                        Criteria :
            </div>
                      {this.fromCriteria()}
                    </Row>
                    <Row className="mt-5 abstract-datatable">
                      <Col sm={12}>
                        <DataTable
                          keyField="abstractId"
                          defaultSortField="title"
                          data={otherMetrics}
                          columns={columns}
                          sizePerPage={[100, 200, 300, 400, 500]}
                          csvName={false}
                          showSearch={true}
                          showPagination={true}
                        />
                      </Col>
                    </Row>
                    {isLoading && (
                      <div className="loader">
                        <FaSpinner />
                      </div>
                    )}
                  </Container>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div className="page-footer-space"></div>
              </td>
            </tr>
          </tfoot>
        </table>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    productData: state.abstractDataReducer.productData,
    usersData: state.userDataReducer.usersData,
    countryData: state.abstractDataReducer.countryData,
    statusData: state.abstractDataReducer.statusData,
    explanationData: state.abstractDataReducer.explanationData
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      loadAllProduct,
      loadAllCountry,
      loadAllExplanation,
      loadAllStatus,
      loadUsersData,
      loadOtherMetrics
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MetricResults)
);